import React, { useState, useEffect } from "react";
import useAuth from "../../../../components/hooks/useAuth";

const ViewBroadcastUploadLeads = (props) => {

  const { broadcastId, setShowUploadLead } = props;
  const { postApi } = useAuth();

  const [fileContent, setFileContent] = useState("");
  const [delimiter, setDelimiter] = useState(",");
  const [numbers, setNumbers] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ Validador
  const validateNumber = (num) => {
    const digits = num.replace(/\D/g, "");

    if (num.startsWith("+")) {
      return digits.length >= 8 && digits.length <= 15;
    }

    return digits.length === 10 || digits.length === 11;
  };

  // 🔧 Parser
  const parseNumbers = (text, delimiter) => {
    if (!text) return [];

    let splitData;

    if (delimiter === "\\n") {
      splitData = text.split(/\r?\n/);
    } else {
      splitData = text.split(delimiter);
    }

    return splitData
      .map(item => item.trim())
      .filter(item => item.length > 0)
      .map(num => ({
        value: num,
        valid: validateNumber(num)
      }));
  };

  // 📂 Upload
  const handleFile = async (file) => {
    if (!file) return;
    const text = await file.text();
    setFileContent(text);
  };

  // ⚡ Reprocessa
  useEffect(() => {
    if (!fileContent) return;
    setNumbers(parseNumbers(fileContent, delimiter));
  }, [delimiter, fileContent]);

  const validNumbers = numbers.filter(n => n.valid);
  const invalidNumbers = numbers.filter(n => !n.valid);

  const handleSubmit = async () => {
    if (validNumbers.length === 0) return;

    setLoading(true);

    const contacts = validNumbers.map(n => ({
      phone_number: n.value
    }));

    let response = await postApi(
      "/api/v1/wpbroadcast/member/toggle/" + broadcastId,
      {
        operation_type: "add",
        contacts
      }
    );

    if (response.status === 'fail') {
      window.alert(response.message);
    } else {
      setShowUploadLead(false);
    }

    setLoading(false);
  };

  return (
    <div style={overlay}>
      <div style={modal}>

        {/* HEADER */}
        <div style={header}>
          <h2 style={{ margin: 0 }}>Importar Leads</h2>
          <button onClick={() => setShowUploadLead(false)} style={closeBtn}>✕</button>
        </div>

        {/* FILE */}
        <div style={{ marginBottom: 16 }}>
          <label style={label}>Arquivo</label>
          <input
            type="file"
            accept=".txt,.csv"
            onChange={(e) => handleFile(e.target.files[0])}
          />
        </div>

        {/* DELIMITER */}
        <div style={{ marginBottom: 16 }}>
          <label style={label}>Delimitador</label>
          <input
            type="text"
            value={delimiter}
            onChange={(e) => setDelimiter(e.target.value)}
            placeholder="Ex: , ; | ou \n"
            style={input}
          />
               <small style={{ color: "#777" }}>
            Use \n para quebra de linha
          </small>
        </div>

        {/* STATS */}
        <div style={stats}>
          <span>Total: {numbers.length}</span>
          <span style={{ color: "green" }}>Válidos: {validNumbers.length}</span>
          <span style={{ color: "red" }}>Inválidos: {invalidNumbers.length}</span>
        </div>

        {/* PREVIEW */}
        <div style={previewBox}>
          <strong>Preview</strong>
          <div style={previewList}>
            {numbers.slice(0, 30).map((n, i) => (
              <div
                key={i}
                style={{
                  ...previewItem,
                  color: n.valid ? "#2e7d32" : "#c62828",
                  fontWeight: n.valid ? "normal" : "bold"
                }}
              >
                #{i + 1} — {n.value}
              </div>
            ))}
          </div>
        </div>

        {/* ACTIONS */}
        <div style={actions}>
          <button onClick={() => setShowUploadLead(false)} style={btnCancel}>
            Cancelar
          </button>

          <button
            onClick={handleSubmit}
            style={{
              ...btnSave,
              opacity: validNumbers.length === 0 ? 0.6 : 1
            }}
            disabled={validNumbers.length === 0}
          >
            {loading ? "Enviando..." : `Importar (${validNumbers.length})`}
          </button>
        </div>

      </div>
    </div>
  );
};

// 🎨 estilos extras

const stats = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 10,
  fontSize: 14
};

// estilos anteriores mantidos

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999
};

const modal = {
  width: 520,
  background: "#fff",
  borderRadius: 12,
  padding: 20,
  boxShadow: "0 10px 40px rgba(0,0,0,0.2)"
};

const header = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 16
};

const closeBtn = {
  border: "none",
  background: "transparent",
  fontSize: 18,
  cursor: "pointer"
};

const label = {
  display: "block",
  fontWeight: 600,
  marginBottom: 6
};

const input = {
  width: "100%",
  padding: 8,
  borderRadius: 8,
  border: "1px solid #ddd"
};

const previewBox = {
  background: "#f9f9f9",
  padding: 12,
  borderRadius: 8,
  marginBottom: 16
};

const previewList = {
  maxHeight: 150,
  overflowY: "auto",
  marginTop: 8
};

const previewItem = {
  fontSize: 14,
  padding: "3px 0",
  borderBottom: "1px solid #eee"
};

const actions = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 8
};

const btnCancel = {
  padding: "8px 12px",
  borderRadius: 8,
  border: "none",
  background: "#eee",
  cursor: "pointer"
};

const btnSave = {
  padding: "8px 12px",
  borderRadius: 8,
  border: "none",
  background: "#51a197",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"
};

export default ViewBroadcastUploadLeads;